import Link from 'next/link';
import localisePath from '@app/lib/helpers/localise-path';
import { Language } from '@app/lib/store-context/Context';

export interface LinkerProps {
    href: string | null;
    lang: Language;
    title: string;
    className?: string;
    target?: string;
    prefetch?: boolean;
    passthrough?: boolean;
    onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
    children: React.ReactNode;
}

function Linker({
    href,
    lang,
    title,
    className,
    target = '_self',
    prefetch = false,
    passthrough = false,
    onClick,
    children,
}: LinkerProps) {
    if (passthrough || !href) {
        return children;
    }
    let targetHref = href;
    const isExternal = href.startsWith('http');
    const containsQuery = href && href.includes('?');
    // There is an issue when MENU items are linking to the same collection
    // with different query params, the collection doesn't refresh.
    // This adds a unique "collection" query param to the URL which
    // can use used to know the collection needs to refresh.
    if (containsQuery && !isExternal) {
        targetHref = `${targetHref}&navigation=1`;
    }
    if (!isExternal) {
        targetHref = localisePath(targetHref, lang);
    }
    return (
        <Link
            href={targetHref}
            prefetch={prefetch}
            passHref={passthrough}
            className={className}
            onClick={onClick}
            title={title}
        >
            {children}
        </Link>
    );
}

export default Linker;
